module.exports = __webpack_public_path__ + "img/control_de_calidad_3-4_1536.6bdbaf03.webp";